import { AppState } from 'Store'

const getAll = (state: AppState) => state.orders.merchantBranches.all
const getEntries = (state: AppState) => state.orders.merchantBranches.all.entries
const getOne = (state: AppState) => state.orders.merchantBranches.one
const getTotal = (state: AppState) => state.orders.merchantBranches.all.total_entries
const getCurrentPage = (state: AppState) => state.orders.merchantBranches.all.current_page
const getParams = (state: AppState) => state.orders.merchantBranches.params
const selectFormState = (state: AppState) => state.orders.merchantBranches.formState

export const merchantBranchesSelector = {
	getAll,
	getEntries,
	getOne,
	getTotal,
	getCurrentPage,
	getParams,
	selectFormState,
}
